<template>
  <div class="page-coupon">
    <van-tabs v-model="active" :ellipsis="false" sticky line-width="18">
      <van-tab v-for="item in couponListTabs" :title="item.title" :name="item.name" :key="item.name" />
    </van-tabs>

    <section
      class="coupon-list"
      :class="{ 'bg-white': active === couponStatusMap.unUsed }"
      v-if="CouponMap[active] && CouponMap[active].list.length"
    >
      <van-list
        :class="{ 'bg-white': active === couponStatusMap.unUsed }"
        v-if="CouponMap[active]"
        v-model="CouponMap[active].loading"
        :finished="CouponMap[active].finished"
        :finished-text="CouponMap[active].list.length > 5 ? '没有更多了' : ''"
        :error-text="CouponMap[active] && CouponMap[active].list.length === 0 ? '' : errorText"
        :error.sync="CouponMap[active].error"
        @load="onLoad"
      >
        <coupon-item
          type="use"
          :showNewIcon="active === couponStatusMap.unUsed || active === couponStatusMap.expired"
          :canSelect="active === couponStatusMap.unUsed"
          :expired="active === couponStatusMap.expired"
          :used="active === couponStatusMap.used"
          :item="coupon"
          v-for="coupon in CouponMap[active].list"
          :key="coupon.couponUserId"
          @useCoupon="onUse"
        />
      </van-list>
      <br />
    </section>
    <van-empty
      class="flex center height100"
      v-else-if="CouponMap[active] && CouponMap[active].list.length === 0 && !CouponMap[active].loading"
      :image="require('@/assets/imgs/list-empty.png')"
      :description="CouponMap[active].error ? errorText : noneText"
    />
  </div>
</template>
<script >
import CouponItem from './components/couponItem';

export default {
  components: {
    CouponItem
  },
  data() {
    return {
      active: 0,

      CouponMap: {},

      couponStatusMap: {
        unUsed: 0,
        expired: 1,
        used: 2
      },

      couponListTabs: [
        {
          name: 0,
          title: '未使用'
        },
        {
          name: 1,
          title: '已过期'
        },
        {
          name: 2,
          title: '已使用'
        }
      ],

      errorText: '系统开小差了，请稍后重试',

      pageSize: 20,

      noneText: '暂无优惠券'
    };
  },

  async mounted() {
    // 初始化tabs 数据list
    this.couponListTabs.forEach((el) => {
      this.$set(this.CouponMap, el.name, {
        list: [],
        pageNo: 1,
        finished: false,
        error: false,
        loading: false
      });
    });
    this.onLoad();
  },

  watch: {
    active() {
      if (this.active === this.couponStatusMap.unUsed) {
        this.noneText = '暂无优惠';
      }
      if (this.active === this.couponStatusMap.expired) {
        this.noneText = '无已过期优惠券';
      }
      if (this.active === this.couponStatusMap.used) {
        this.noneText = '无已使用优惠券';
      }
      if (!this.CouponMap[this.active].finished) {
        this.onLoad();
      }
    }
  },
  methods: {
    async onLoad() {
      if (this.CouponMap[this.active].finished) return;
      this.CouponMap[this.active].loading = true;

      const { active } = this;
      try {
        const newCoupons = await this.fetchData(this.active);
        const existData = this.CouponMap[active].list || [];
        const { hasMore, couponItemInfoVOS } = newCoupons;
        this.CouponMap[active].pageNo += 1;

        existData.push(...couponItemInfoVOS);
        this.CouponMap[active].list = existData;

        if (!hasMore) {
          this.CouponMap[active].finished = true;
        }
      } catch (error) {
        this.errorText = error.message || this.errorText;
        this.CouponMap[active].error = true;
      } finally {
        this.CouponMap[active].loading = false;
      }
    },

    async fetchData(status) {
      return this.$fetch.getCouponList({
        status,
        pageNo: this.CouponMap[this.active].pageNo,
        pageSize: this.pageSize
      });
    },

    onUse(coupon) {
      this.$router.push({
        name: 'searchCouponGoods',
        query: {
          couponId: coupon.id
        }
      });
    }
  }
};
</script>
<style lang="less" scoped>
.bg-white {
  background-color: #ffffff !important;
}
.page-coupon {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 100%;

  .coupon-list {
    flex: 1;
    overflow: auto;
    padding: 12px 16px;
    background-color: #f5f5f5;
  }
  // /deep/ .bottom-tab .right {
  //   flex: none;
  //   width: 128px;
  // }
  // /deep/ .van-nav-bar__right {
  //   color: #1e8dff;
  //   font-weight: normal;
  // }
  /deep/ .van-tabs--line .van-tabs__wrap {
    border-bottom: 0.5px solid #eee;
  }
  .placehold-text {
    margin-top: 8px;
    font-size: 16px;
    color: #8c8c8c;
  }
  .height100 {
    height: 100%;
  }
}
.button-wrap {
  height: 56px;
  padding: 8px 16px;
  background: #fff;
  > button {
    width: 100%;
  }
}
</style>
